import _classCallCheck from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/createSuper";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */
// @ts-nocheck


import Deferred from './deferred';
import EventTarget from './eventtarget';
/**
 * An {@link AudioPlayer} is an HTMLAudioElement-like object that uses AudioContext
 *   to circumvent browser limitations.
 * @private
 */

var AudioPlayer = /*#__PURE__*/function (_EventTarget) {
  _inherits(AudioPlayer, _EventTarget);

  var _super = _createSuper(AudioPlayer);

  /**
   * @private
   */
  function AudioPlayer(audioContext) {
    var _this;

    var srcOrOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, AudioPlayer);

    _this = _super.call(this);
    /**
     * The AudioBufferSourceNode of the actively loaded sound. Null if a sound
     *   has not been loaded yet. This is re-used for each time the sound is
     *   played.
     */

    _this._audioNode = null;
    /**
     * Whether or not the audio element should loop. If disabled during playback,
     *   playing continues until the sound ends and then stops looping.
     */

    _this._loop = false;
    /**
     * An Array of deferred-like objects for each pending `play` Promise. When
     *   .pause() is called or .src is set, all pending play Promises are
     *   immediately rejected.
     */

    _this._pendingPlayDeferreds = [];
    /**
     * The current sinkId of the device audio is being played through.
     */

    _this._sinkId = 'default';
    /**
     * The source URL of the sound to play. When set, the currently playing sound will stop.
     */

    _this._src = '';

    if (typeof srcOrOptions !== 'string') {
      options = srcOrOptions;
    }

    _this._audioContext = audioContext;
    _this._audioElement = new (options.AudioFactory || Audio)();
    _this._bufferPromise = _this._createPlayDeferred().promise;
    _this._destination = _this._audioContext.destination;
    _this._gainNode = _this._audioContext.createGain();

    _this._gainNode.connect(_this._destination);

    _this._XMLHttpRequest = options.XMLHttpRequestFactory || XMLHttpRequest;

    _this.addEventListener('canplaythrough', function () {
      _this._resolvePlayDeferreds();
    });

    if (typeof srcOrOptions === 'string') {
      _this.src = srcOrOptions;
    }

    return _this;
  }

  _createClass(AudioPlayer, [{
    key: "destination",
    get: function get() {
      return this._destination;
    }
  }, {
    key: "loop",
    get: function get() {
      return this._loop;
    },
    set: function set(shouldLoop) {
      var self = this;

      function pauseAfterPlaythrough() {
        self._audioNode.removeEventListener('ended', pauseAfterPlaythrough);

        self.pause();
      } // If a sound is already looping, it should continue playing
      //   the current playthrough and then stop.


      if (!shouldLoop && this.loop && !this.paused) {
        this._audioNode.addEventListener('ended', pauseAfterPlaythrough);
      }

      this._loop = shouldLoop;
    }
    /**
     * Whether the audio element is muted.
     */

  }, {
    key: "muted",
    get: function get() {
      return this._gainNode.gain.value === 0;
    },
    set: function set(shouldBeMuted) {
      this._gainNode.gain.value = shouldBeMuted ? 0 : 1;
    }
    /**
     * Whether the sound is paused. this._audioNode only exists when sound is playing;
     *   otherwise AudioPlayer is considered paused.
     */

  }, {
    key: "paused",
    get: function get() {
      return this._audioNode === null;
    }
  }, {
    key: "src",
    get: function get() {
      return this._src;
    },
    set: function set(src) {
      this._load(src);
    }
    /**
     * The srcObject of the HTMLMediaElement
     */

  }, {
    key: "srcObject",
    get: function get() {
      return this._audioElement.srcObject;
    },
    set: function set(srcObject) {
      this._audioElement.srcObject = srcObject;
    }
  }, {
    key: "sinkId",
    get: function get() {
      return this._sinkId;
    }
    /**
     * Stop any ongoing playback and reload the source file.
     */

  }, {
    key: "load",
    value: function load() {
      this._load(this._src);
    }
    /**
     * Pause the audio coming from this AudioPlayer. This will reject any pending
     *   play Promises.
     */

  }, {
    key: "pause",
    value: function pause() {
      if (this.paused) {
        return;
      }

      this._audioElement.pause();

      this._audioNode.stop();

      this._audioNode.disconnect(this._gainNode);

      this._audioNode = null;

      this._rejectPlayDeferreds(new Error('The play() request was interrupted by a call to pause().'));
    }
    /**
     * Play the sound. If the buffer hasn't loaded yet, wait for the buffer to load. If
     *   the source URL is not set yet, this Promise will remain pending until a source
     *   URL is set.
     */

  }, {
    key: "play",
    value: function play() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2 = this;

        var buffer;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.paused) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return this._bufferPromise;

              case 3:
                if (this.paused) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                throw new Error('The play() request was interrupted by a call to pause().');

              case 6:
                this._audioNode = this._audioContext.createBufferSource();
                this._audioNode.loop = this.loop;

                this._audioNode.addEventListener('ended', function () {
                  if (_this2._audioNode && _this2._audioNode.loop) {
                    return;
                  }

                  _this2.dispatchEvent('ended');
                });

                _context.next = 11;
                return this._bufferPromise;

              case 11:
                buffer = _context.sent;

                if (!this.paused) {
                  _context.next = 14;
                  break;
                }

                throw new Error('The play() request was interrupted by a call to pause().');

              case 14:
                this._audioNode.buffer = buffer;

                this._audioNode.connect(this._gainNode);

                this._audioNode.start();

                if (!this._audioElement.srcObject) {
                  _context.next = 19;
                  break;
                }

                return _context.abrupt("return", this._audioElement.play());

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Change which device the sound should play through.
     * @param sinkId - The sink of the device to play sound through.
     */

  }, {
    key: "setSinkId",
    value: function setSinkId(sinkId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(typeof this._audioElement.setSinkId !== 'function')) {
                  _context2.next = 2;
                  break;
                }

                throw new Error('This browser does not support setSinkId.');

              case 2:
                if (!(sinkId === this.sinkId)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                if (!(sinkId === 'default')) {
                  _context2.next = 11;
                  break;
                }

                if (!this.paused) {
                  this._gainNode.disconnect(this._destination);
                }

                this._audioElement.srcObject = null;
                this._destination = this._audioContext.destination;

                this._gainNode.connect(this._destination);

                this._sinkId = sinkId;
                return _context2.abrupt("return");

              case 11:
                _context2.next = 13;
                return this._audioElement.setSinkId(sinkId);

              case 13:
                if (!this._audioElement.srcObject) {
                  _context2.next = 15;
                  break;
                }

                return _context2.abrupt("return");

              case 15:
                this._gainNode.disconnect(this._audioContext.destination);

                this._destination = this._audioContext.createMediaStreamDestination();
                this._audioElement.srcObject = this._destination.stream;
                this._sinkId = sinkId;

                this._gainNode.connect(this._destination);

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Create a Deferred for a Promise that will be resolved when .src is set or rejected
     *   when .pause is called.
     */

  }, {
    key: "_createPlayDeferred",
    value: function _createPlayDeferred() {
      var deferred = new Deferred();

      this._pendingPlayDeferreds.push(deferred);

      return deferred;
    }
    /**
     * Stop current playback and load a sound file.
     * @param src - The source URL of the file to load
     */

  }, {
    key: "_load",
    value: function _load(src) {
      var _this3 = this;

      if (this._src && this._src !== src) {
        this.pause();
      }

      this._src = src;
      this._bufferPromise = new Promise(function (resolve, reject) {
        return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
          var buffer;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (src) {
                    _context3.next = 2;
                    break;
                  }

                  return _context3.abrupt("return", this._createPlayDeferred().promise);

                case 2:
                  _context3.next = 4;
                  return bufferSound(this._audioContext, this._XMLHttpRequest, src);

                case 4:
                  buffer = _context3.sent;
                  this.dispatchEvent('canplaythrough');
                  resolve(buffer);

                case 7:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));
      });
    }
    /**
     * Reject all deferreds for the Play promise.
     * @param reason
     */

  }, {
    key: "_rejectPlayDeferreds",
    value: function _rejectPlayDeferreds(reason) {
      var deferreds = this._pendingPlayDeferreds;
      deferreds.splice(0, deferreds.length).forEach(function (_ref) {
        var reject = _ref.reject;
        return reject(reason);
      });
    }
    /**
     * Resolve all deferreds for the Play promise.
     * @param result
     */

  }, {
    key: "_resolvePlayDeferreds",
    value: function _resolvePlayDeferreds(result) {
      var deferreds = this._pendingPlayDeferreds;
      deferreds.splice(0, deferreds.length).forEach(function (_ref2) {
        var resolve = _ref2.resolve;
        return resolve(result);
      });
    }
  }]);

  return AudioPlayer;
}(EventTarget);
/**
 * Use XMLHttpRequest to load the AudioBuffer of a remote audio asset.
 * @private
 * @param context - The AudioContext to use to decode the audio data
 * @param RequestFactory - The XMLHttpRequest factory to build
 * @param src - The URL of the audio asset to load.
 * @returns A Promise containing the decoded AudioBuffer.
 */
// tslint:disable-next-line:variable-name


function bufferSound(context, RequestFactory, src) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var request, event;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            request = new RequestFactory();
            request.open('GET', src, true);
            request.responseType = 'arraybuffer';
            _context4.next = 5;
            return new Promise(function (resolve) {
              request.addEventListener('load', resolve);
              request.send();
            });

          case 5:
            event = _context4.sent;
            _context4.prev = 6;
            return _context4.abrupt("return", context.decodeAudioData(event.target.response));

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](6);
            return _context4.abrupt("return", new Promise(function (resolve) {
              context.decodeAudioData(event.target.response, resolve);
            }));

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[6, 10]]);
  }));
}

export default AudioPlayer;